import React from 'react'
import Base from '../core/Base';

const  Orders = ()=> {
    return (
        <Base>
          <h1 className="text-white">orders</h1>  
        </Base>
    )
}
export default Orders;